import { lazy, Suspense, useState } from "react";
import { useMe, useTab } from "../api/queries";
import { Button } from "../design/components/Button";
import { useT } from "../i18n/locale";
import { useAccess } from "../session/access";
import { commercialViewOf, tabKey, type TabContext } from "../session/tab-context";
const FileImportDialog = lazy(() => import("./FileImportDialog").then((module) => ({ default: module.FileImportDialog })));

export function FileImportButton() {
  const access = useAccess();
  const tab = useTab();
  const me = useMe();
  if (!(access.isPlatform || access.can("import_leads")) || commercialViewOf(tab) !== null) return null;
  return <FileImportLauncher key={`${tabKey(tab)}:${me.id}`} tab={tab} userId={me.id} />;
}

function FileImportLauncher({ tab, userId }: { tab: TabContext; userId: string }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  return <>
    <Button aria-haspopup="dialog" onClick={() => setOpen(true)}>{t("fileImport.title")}</Button>
    {open ? <Suspense fallback={<p role="status">{t("fileImport.reading")}</p>}><FileImportDialog tab={tab} userId={userId} onClose={() => setOpen(false)} /></Suspense> : null}
  </>;
}
